import { css, keyframes } from '@emotion/react';

import { Alert, Animation } from '@zapier/design-system';

import { Notification as NotificationType } from '../types';
import useTimer from './useTimer';

type Props = {
  index: number;
  notification: NotificationType;
  onDismiss: (id: string) => void;
  timeout: number;
};

const openAnimation = keyframes({
  '0%': {
    opacity: 0,
    transform: 'translateY(-10px)',
  },

  '100%': {
    opacity: 1,
    transform: 'translateY(0)',
  },
  // This "delay" gives enough time for the menu to be measured
  // by `useIntersect` and flip upwards if it needs to, without
  // flickering for a moment while it renders down and is measured.
  '30%': {
    opacity: 0,
    transform: 'translateY(-10px)',
  },
});

const rootStyle = css`
  animation: ${Animation.transitionDuration} ease-out ${openAnimation};
  max-width: 90vw;
  width: 700px;
  // To get it to render on top of google one tap
  z-index: 999;
`;

/**
 * A popup toast-style notification
 */
function Notification({ notification, onDismiss, timeout }: Props) {
  function handleDismiss() {
    if (notification.onDismiss) {
      notification.onDismiss(notification);
    }
    onDismiss(notification.id);
  }

  const { onPause, onResume } = useTimer(handleDismiss, timeout);

  const alertProps = {
    onDismiss: handleDismiss,
    status: notification.type,
    title: notification.title,
  };

  return (
    <div css={rootStyle} onMouseEnter={onPause} onMouseLeave={onResume}>
      <Alert {...alertProps}>{notification.message}</Alert>
    </div>
  );
}

export default Notification;
